import { useMemo } from 'react';

import type { MarketplaceIntegrationSpecVersionOut } from '@repo/api-codegen';
import { TextRender } from '../../components/TableV2/render';
import type { ExtendedDataTableColumn } from '../../components/TableV2/types';
import { useColumns as useMarketplaceIntegrationSpecVersionsColumns } from '../MarketplaceIntegrationSpecDetailPage/MarketplaceIntegrationSpecDetailPage.hooks';

export const useColumns =
	(): ExtendedDataTableColumn<MarketplaceIntegrationSpecVersionOut>[] => {
		const marketplaceIntegrationSpecVersionsColumns =
			useMarketplaceIntegrationSpecVersionsColumns();

		const columns: ExtendedDataTableColumn<MarketplaceIntegrationSpecVersionOut>[] =
			useMemo(
				() => [
					...marketplaceIntegrationSpecVersionsColumns.filter(
						(el) => el.accessor !== 'action'
					),
					{
						titleLabel: 'Comments',
						accessor: 'reviewer_comment',
						render: (record) => (
							<TextRender record={record} field="reviewer_comment" />
						),
					},
					{
						titleLabel: 'Reviewer',
						accessor: 'reviewer_email',
						render: (record) => (
							<TextRender record={record} field="reviewer_email" />
						),
					},
				],
				[marketplaceIntegrationSpecVersionsColumns]
			);

		return columns;
	};
